/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

export interface HistoricalDataFilters {
  cape: "shiller" | "ern"
  firstStartingYear: number
  lastStartingYear: number
  minAbsDrawdown: number // Minimum drawdown filter (0-1 range)
  maxAbsDrawdown: number // Maximum drawdown filter (0-1 range)
  minCape: number // Minimum CAPE value filter
  maxCape: number // Maximum CAPE value filter
}

export const initialHistoricalDataFilters: HistoricalDataFilters = {
  cape: "ern",
  firstStartingYear: 1871, // Default value. Won't be visible to use and will be updated with actual min.
  lastStartingYear: 2015, // Default value. Won't be visible to use and will be updated with actual max.
  minAbsDrawdown: 0.0, // Default value: no minimum drawdown filter
  maxAbsDrawdown: 1.0, // Default value: maximum possible drawdown (100%)
  minCape: 0.0, // Default value: no minimum CAPE filter
  maxCape: 100.0, // Default value: high maximum CAPE that will be updated with actual max
}
